<mat-card>
  <mat-card-content>
    <app-terms-display
      [type]="'usdPad'"
      [header]="'PAD terms'"
      [message]="'You have a USD bank account linked to your TUIO account.'"
      [skippable]="skippable"
      (submitted)="submit()"
      (skipped)="skip()">
    </app-terms-display>
  </mat-card-content>
</mat-card>